var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"verification-notice"},[_c('h1',[_vm._v(_vm._s(_vm.$t(`Email Verification Success`)))]),_c('p',{staticClass:"email-desc"},[_vm._v(_vm._s(_vm.$t(`Your email has been successfully verified`))+". "+_vm._s(_vm.$t(`Thank you`))+"!")])])
}
var staticRenderFns = []

export { render, staticRenderFns }